<template>
  <div class="admin-login-log">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="操作日志" name="oper"></el-tab-pane>
        <el-tab-pane label="登录日志" name="login"></el-tab-pane>
        <el-tab-pane label="风控日志" name="risk"></el-tab-pane>
      </el-tabs>

      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-input
              v-if="activeTab !== 'risk'"
              v-model="searchUsername"
              :placeholder="activeTab === 'oper' ? '操作账号' : '登录账号'"
              prefix-icon="el-icon-search"
              clearable
              class="filter-input"
              @keyup.enter.native="handleSearch"
            />
            <el-input
              v-else
              v-model="searchKeyword"
              placeholder="openid / 用户ID"
              prefix-icon="el-icon-search"
              clearable
              class="filter-input"
              @keyup.enter.native="handleSearch"
            />
            <el-select
              v-if="activeTab === 'risk'"
              v-model="filterRiskType"
              placeholder="风控类型"
              clearable
              class="filter-select"
              @change="handleSearch"
            >
              <el-option label="阿里云" value="ALIYUN" />
              <el-option label="客户端" value="CLIENT" />
              <el-option label="同IP设备" value="IP_DEVICE" />
              <el-option label="封禁" value="BAN" />
            </el-select>
            <el-select
              v-if="activeTab === 'risk'"
              v-model="filterBlocked"
              placeholder="是否拦截"
              clearable
              class="filter-select-sm"
              @change="handleSearch"
            >
              <el-option label="已拦截" :value="1" />
              <el-option label="未拦截" :value="0" />
            </el-select>
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              class="filter-daterange"
              @change="handleSearch"
            />
            <date-range-quick v-model="dateRange" @change="handleSearch" />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table
        :key="activeTab"
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        row-key="id"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />

        <template v-if="activeTab === 'risk'">
          <el-table-column label="时间" width="170" align="center">
            <template slot-scope="scope">
              {{ formatTime(scope.row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="用户" min-width="130" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatUser(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="openid" label="openid" min-width="160" show-overflow-tooltip />
          <el-table-column prop="ip" label="IP" width="130" show-overflow-tooltip />
          <el-table-column prop="riskTypeLabel" label="类型" width="120" show-overflow-tooltip />
          <el-table-column prop="riskSubType" label="子类型" width="110" show-overflow-tooltip />
          <el-table-column prop="reason" label="原因" min-width="180" show-overflow-tooltip />
          <el-table-column label="拦截" width="80" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.blocked ? 'danger' : 'info'" size="mini">
                {{ scope.row.blocked ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="userStatusLabel" label="用户状态" width="90" align="center" />
        </template>

        <template v-else>
          <el-table-column
            prop="username"
            :label="activeTab === 'oper' ? '操作人' : '登录账号'"
            min-width="110"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="activeTab === 'oper'"
            prop="module"
            label="模块"
            width="120"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="activeTab === 'oper'"
            prop="action"
            label="操作"
            min-width="320"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="activeTab === 'login'"
            prop="loginIp"
            label="登录IP"
            min-width="140"
            show-overflow-tooltip
          />
          <el-table-column
            v-if="activeTab === 'login'"
            prop="loginLocation"
            label="登录地点"
            min-width="150"
            show-overflow-tooltip
          />
          <el-table-column
            :label="activeTab === 'oper' ? '时间' : '登录时间'"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatTime(scope.row.loginTime) }}
            </template>
          </el-table-column>
        </template>
      </el-table>

      <div v-if="!error && !loading && list.length === 0" class="empty-state">
        <el-empty :description="emptyText" />
      </div>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http.js'
import { getDefaultDateRange } from '@/utils/dateRange'
import DateRangeQuick from '@/components/DateRangeQuick.vue'

export default {
  name: 'AdminLoginLog',
  components: { DateRangeQuick },
  data() {
    return {
      activeTab: 'oper',
      list: [],
      loading: false,
      error: '',
      searchUsername: '',
      searchKeyword: '',
      filterRiskType: '',
      filterBlocked: null,
      dateRange: getDefaultDateRange(),
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  computed: {
    emptyText() {
      if (this.activeTab === 'oper') return '暂无操作日志'
      if (this.activeTab === 'login') return '暂无登录日志'
      return '暂无风控日志'
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatTime(val) {
      if (!val) return '-'
      return String(val).replace('T', ' ')
    },
    formatUser(row) {
      if (!row) return '-'
      const phone = row.phone || ''
      const nickname = row.nickname || ''
      if (phone && nickname) return `${phone} / ${nickname}`
      return phone || nickname || (row.userId != null ? `UID:${row.userId}` : '-')
    },
    normalizeRow(row) {
      if (!row || typeof row !== 'object') return row
      return {
        ...row,
        loginIp: row.loginIp || row.login_ip || '-',
        loginLocation: row.loginLocation || row.login_location || '未知',
        loginTime: row.loginTime || row.login_time || '',
        createdAt: row.createdAt || row.created_at || '',
        riskTypeLabel: row.riskTypeLabel || row.risk_type_label || row.riskType || '-',
        riskSubType: row.riskSubType || row.risk_sub_type || '',
        userStatusLabel: row.userStatusLabel || row.user_status_label || '-',
        blocked: row.blocked === true || row.blocked === 1
      }
    },
    handleTabClick(tab) {
      if (tab && tab.name) {
        this.activeTab = tab.name
      }
      this.pagination.page = 1
      this.$nextTick(() => this.fetchList())
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        if (this.activeTab === 'risk') {
          await this.fetchRiskList()
        } else {
          await this.fetchLoginLogList()
        }
      } catch (e) {
        this.list = []
        this.pagination.total = 0
        this.error = (e && e.message) || '获取系统日志失败'
      } finally {
        this.loading = false
      }
    },
    async fetchLoginLogList() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        logType: this.activeTab === 'oper' ? 1 : 0
      }
      if (this.searchUsername) params.username = this.searchUsername.trim()
      const [start, end] = this.dateRange || []
      if (start) params.startTime = start
      if (end) params.endTime = end

      const result = await get('/admin/login-log/page', params)
      this.applyPageResult(result)
    },
    async fetchRiskList() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      if (this.searchKeyword) params.keyword = this.searchKeyword.trim()
      if (this.filterRiskType) params.riskType = this.filterRiskType
      if (this.filterBlocked === 0 || this.filterBlocked === 1) {
        params.blocked = this.filterBlocked
      }
      const [start, end] = this.dateRange || []
      if (start) params.startTime = start
      if (end) params.endTime = end

      const result = await get('/admin/risk/events/page', params)
      this.applyPageResult(result)
    },
    applyPageResult(result) {
      const data = result.data || {}
      const records = Array.isArray(data.records)
        ? data.records
        : (Array.isArray(data.list) ? data.list : [])
      this.list = records.map(this.normalizeRow)
      this.pagination.total = Number(data.total || 0)
      if (data.page) this.pagination.page = Number(data.page)
      if (data.pageSize) this.pagination.pageSize = Number(data.pageSize)
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    handleReset() {
      this.searchUsername = ''
      this.searchKeyword = ''
      this.filterRiskType = ''
      this.filterBlocked = null
      this.dateRange = getDefaultDateRange()
      this.pagination.page = 1
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.filter-input {
  width: 180px;
}
.filter-select {
  width: 130px;
}
.filter-select-sm {
  width: 110px;
}
.filter-daterange {
  width: 380px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
.empty-state {
  padding: 24px 0;
}
</style>
